import { Direction } from '../../../../shared/types/Direction'
import { PaginatedData } from '../../../../shared/types/PaginatedData'

export interface MtInfo {
	serverName: string
	serverOwner: string
	updateTime: string
}

export interface Ip {
	ip: string
	updateTime: string
}

export enum InstanceState {
	ACTIVE = 'active',
	DEACTIVATED = 'deactivated'
}

export enum InstanceLabel {
	LIVE = 'live',
	DEMO = 'demo',
	BACKUP = 'backup',
	TECHNICAL = 'technical'
}

export type USAGE_STATUS = 'Likely unused' | 'Possibly unused'
export type UsageStatusReason = 'stale_renewal' | 'same_ip_newer' | 'outdated_version'

export interface InstancesBrief {
	instanceId: string
	instanceName: string
	ip: Array<Ip>
}

export interface IInstance extends InstancesBrief {
	mtInfo: Array<MtInfo>
	productVersion: string
	componentName: string
	state: InstanceState
	lastRenewalTime: string
	initializationTime: string
	label: InstanceLabel
	functionalityValues: Record<string, number>
	usageStatus: USAGE_STATUS,
	usageStatusReasons: UsageStatusReason[],
	usageStatusContext: Record<string, string>,
}

export interface InstancesFilter {
	instanceName?: string
	label?: InstanceLabel
	ip?: string
	productVersion?: string
}

export interface InstancesSchema {
	isLoading: boolean
	error?: string
	paginatedInstances: PaginatedData<IInstance>
	limit: number
	queryFilter: InstancesFilter,
	filter: InstancesFilter
	sort: {
		direction?: Direction
		sort?: string
	}

	funcCurrentValuesMinMax: Record<
		/*funcTempId*/ string,
		/* least-greatest currentValue*/ {
		least: number,
		greatest: number
	}>

	allInstances: {
		isLoading: boolean
		error?: string
		items: IInstance[]
	}
}
